// extracted by mini-css-extract-plugin
module.exports = {"root":"IconFavorite_root__3IHu0","rootActive":"IconFavorite_rootActive__3v4BP"};